/**
 * Cross-tab auth event bus. A `logout` posted from one tab (explicit sign-out
 * or a 401 flip) reaches every other tab in the same browser, so the UI
 * doesn't sit on stale "logged-in" state until the next request fails.
 */

export type AuthEvent = { type: "logout" };

const channel: BroadcastChannel | null =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel("hawk-auth")
    : null;

export function postLogout(): void {
  channel?.postMessage({ type: "logout" } satisfies AuthEvent);
}

export function subscribe(handler: (event: AuthEvent) => void): () => void {
  if (!channel) return () => {};
  const listener = (e: MessageEvent<AuthEvent>) => handler(e.data);
  channel.addEventListener("message", listener);
  return () => channel.removeEventListener("message", listener);
}
